var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showOverlay)?_c('div',{staticClass:"overlay",class:_vm.displayedCSS}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }